<template>
    <section class="welcome-banner bg-design">
        <div class="page-container">
            <div class="promo-box">
                <p class="text-h5 mb-20">
                    Celebrate the Season with Extra Rewards!
                </p>
                <p class="text-h1 mb-20">
                    Earn <span class="color-primary">100</span> bonus points<sup>*</sup>
                </p>
                <p class="text-h6">
                    when you redeem two offers by 12/31. Make your holiday shopping even more rewarding with Beyond Ulta Beauty Rewards<sup>&#8482;</sup>!
                </p>
            </div>

        </div>
    </section>
</template>

<script>
export default {
    name: "InnerWelcomeBannerComponent",
    methods: {

    }
}
</script>
<style scoped>
    .promo-box {
        max-width: 922px;
        background-color: white;
        border-radius: 30px;
        padding: 40px;
        p {
            line-height: 1;
        }
        .text-h5 {
            font-weight: 700;
            font-size: 20px;
            color: black;
            text-transform: uppercase;
        }
        .text-h1 {
            font-weight: 700;
            font-size: 76px;
            color: black;
        }
        .text-h6 {
            font-weight: 400;
            font-size: 24px;
            color: black;
        }
        .color-primary {
            color:#E90B5A;
        }
    }

</style>
